export default __webpack_public_path__ + "static/media/icon-search.a0356cd6.svg";